import React, { lazy, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { BookMarkIcon, CheckCircleIcon, ClockIcon, HardDriveIcon, PowerOff } from '../components/icons';
import LeftBar from '../components/left';
import { ACTIONS } from '../redux/actions';
import request from '../utils/request';
import routes from '../utils/routes';
import { setLoading } from '../redux/actions/index';
import JobsDescription from '../pages/Jobs/JobDescription/index';



const Login = lazy(() => import("../pages/login"))
const MyApplication = lazy(() => import('../pages/MyApplication'));
const MyOffers = lazy(() => import('../pages/MyOffers'));
const Jobs = lazy(() => import("../pages/Jobs"))
const MyProfile = lazy(() => import('../pages/MyProfile'));
const MyHistory = lazy(() => import('../pages/MyHistory'));
const Logout = lazy(() => import('../pages/Logout'));
const JobDescription = lazy(() => import('../pages/Jobs/JobDescription'));
const Onboarding = lazy(() => import('../pages/Onboarding'));

const LeftWrapper = ({ children }: { children: JSX.Element }) => {
    return <LeftBar>{children}</LeftBar>
}

const JobsComponent = () => {
    return <AuthenticateRoute useAuth={false}>
        <LeftWrapper><Jobs></Jobs></LeftWrapper>
    </AuthenticateRoute>
}
const JobsDescriptionComponent = () => {
    return <AuthenticateRoute useAuth={false}>
        <LeftWrapper><JobsDescription useAuth={false}></JobsDescription></LeftWrapper>
    </AuthenticateRoute>
}
const MyApplicationComponent = () => {
    return <AuthenticateRoute >
        <LeftWrapper><MyApplication /></LeftWrapper>
    </AuthenticateRoute>
}

const MyApplicationDescriptionComponent = () => {
    return <AuthenticateRoute >
        <LeftWrapper><JobsDescription useAuth={false}></JobsDescription></LeftWrapper>
    </AuthenticateRoute>
}

const MyOffersComponent = () => {
    return <AuthenticateRoute>
        <LeftWrapper><MyOffers /></LeftWrapper>
    </AuthenticateRoute>
}

const MyOffersDescriptionComponent = () => {
    return <AuthenticateRoute useAuth={true}>
        <LeftWrapper><JobsDescription ></JobsDescription></LeftWrapper>
    </AuthenticateRoute>
}
const MyProfileComponent = () => {
    return <AuthenticateRoute >
        <LeftWrapper><MyProfile ></MyProfile></LeftWrapper>
    </AuthenticateRoute>
}

const OnboardingComponent = () => {
  return <AuthenticateRoute>
      <Onboarding></Onboarding>
  </AuthenticateRoute>
}

function AuthenticateRoute({ children, useAuth = true }: { children: JSX.Element, useAuth?: boolean }): JSX.Element {
    const user = useSelector((state: any) => state.appReducer.userInfo);
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        setLoading(true);
        if (!Object.keys(user).length) {
            (async () => {
                const result = await request({
                    url: routes.login,
                    method: "GET",
                    dispatch,
                    navigate: useAuth ? navigate : undefined,
                    location: useAuth ? location : undefined,
                    useLoader: false
                })
                if (result?.statusCode === 200) {
                    dispatch({ type: ACTIONS.USERINFO, userInfo: result?.payload });
                }
                result && setLoading(false)
            })()
        } else {
            setLoading(false)
        }
    }, [children])

    if (loading) {
        return <> <div className="loading">loading </div></>
    }
    return children
}
const menuList = [
    {
        "label": "",
        "element": <Login page={"login"} />,
        "path": "/login",
        "icon": null,
        children: []
    },
    {
        "label": "",
        "element": <Login page={"signup"} />,
        "path": "/signup",
        "icon": null,
        children: []
    },
    {
        "label": "",
        "element": <Login page={"forgotpassword"} />,
        "path": "/forgotpassword",
        "icon": null,
        children: []
    },
    {
        "label": "",
        "element": <Login page={"resetpassword"} />,
        "path": "/resetpassword",
        "icon": null,
        children: []
    },
    {
        "label": "Jobs",
        "element": <JobsComponent />,
        "path": "/",
        "exact": true,
        "icon": CheckCircleIcon,
    },
    {
        "label": "",
        "element": <JobsDescriptionComponent />, //<AuthenticateRoute Element={() => <LeftWrapper><JobDescription /></LeftWrapper>} useAuth={false}></AuthenticateRoute>,
        "path": "/:id",
    },
    {
        "label": "My Applications",
        "element": <MyApplicationComponent />,
        "path": "/my-applications",
        "icon": ClockIcon
    },
    {
        "label": "",
        "element": <MyApplicationDescriptionComponent />,
        "path": "/my-applications/:id"
    },
    {
        "label": "My Offers",
        "element": <MyOffersComponent />,
        "path": "/my-offers",
        "icon": HardDriveIcon
    },
    {
        "label": "",
        "element": <MyOffersDescriptionComponent />,
        "path": "/my-offers/:id",
    },
    {
      "label": "",
      "element": <OnboardingComponent />,
      "path": "/onboarding/:id",
    },
    {
        "label": "My Profile",
        "element": <MyProfileComponent />,
        "path": "/my-profile",
        "icon": BookMarkIcon
    },
    
    // {
    //     "label": "My History",
    //     "element": <AuthWrapper><LeftWrapper><MyHistory /></LeftWrapper></AuthWrapper>,
    //     "path": "/my-history",
    //     "icon": ThumpsUpIcon
    // },
    {
        "label": "Logout",
        "showOnLogin": true,
        "element": <LeftWrapper><Logout /></LeftWrapper>,
        "path": "/logout",
        "icon": PowerOff
    },
    {
        "label": "",
        "element": null,
        "path": "*",
        "icon": PowerOff
    }
]

export default menuList;